import gql from "graphql-tag";

export default gql`
  mutation UpdateCustomer($customerId: ID, $customerInput: CustomerInputInput) {
    updateCustomer(customerId: $customerId, customerInput: $customerInput) {
      id
      description
    }
  }
`;
